import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { HealtheraButton } from '../../../../healtheraComponents';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import { enqueueSnackbar } from 'notistack';
import { useCreateMasterMedicine } from '../../../../apis/master-medicines/hooks/useCreateMasterMedicine';
import { useHistory } from 'react-router';

interface Props {
  form: UseFormReturn<MasterMedicine>;
}

const CreateMasterMedicine = ({ form }: Props) => {
  const { createMasterMedicine, isLoading } = useCreateMasterMedicine();
  const history = useHistory();

  const handleSave = async (masterMedicine: MasterMedicine) => {
    const response = await createMasterMedicine(masterMedicine);
    enqueueSnackbar('Master medicine created', { variant: 'success' });
    history.replace(`/clinics/master-medicines/${response._id}`);
  };

  const handleInvalidForm = () => {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={form.handleSubmit(handleSave, handleInvalidForm)}>
      Create
    </HealtheraButton>
  );
};

export default CreateMasterMedicine;
